const fetchData = (productType, status, filter) => {
  return fetch(`/api/custom-orders/${productType}/${status}/${filter}`, {
    method: "get",
    headers: {
      Accept: "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      const error = new Error(res.statusText);
      error.json = res.json();
      throw error;
    }

    return res.json();
  });
};

const putData = (order, status) => {
  return fetch(`/api/custom-orders/${order.id}`, {
    method: "put",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
    },
    body: JSON.stringify({
      status: status,
    }),
  }).then((res) => {
    if (!res.ok) {
      const error = new Error(res.statusText);
      error.json = res.json();
      throw error;
    }

    return res.json();
  });
};

const deleteData = (order) => {
  return fetch(`/api/custom-orders/${order.id}`, {
    method: "delete",
    headers: {
      Accept: "application/json",
      "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
    },
  }).then((res) => {
    if (!res.ok) {
      const error = new Error(res.statusText);
      error.json = res.json();
      throw error;
    }

    return res.json();
  });
};

const exportData = (productType) => {
  return fetch(`/api/custom-orders/${productType}/export`, {
    method: "get",
    headers: {
      Accept: "application/json",
    },
  }).then((res) => res.json());
};

const replaceImage = (order, image) => {
  return fetch(`/api/custom-orders/${order.id}/replace-image`, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
    },
    body: JSON.stringify({
      image: image,
    }),
  }).then((res) => res.json());
};

const searchOrders = (intent) => {
  return fetch(`/api/custom-orders/search/${intent}/${orderId}`, {
    method: "get",
    headers: {
      Accept: "application/json",
    },
  }).then((res) => res.json());
};

const importOrder = (orderId) => {
  return fetch(`/api/custom-orders/import/${orderId}`, {
    method: "get",
    headers: {
      Accept: "application/json",
    },
  }).then((res) => res.json());
};

export { fetchData, putData, deleteData, exportData, replaceImage, searchOrders, importOrder };
